import View from '../view';

import { pick, } from '../../utils/popups';



export default View.extend( {

    serialize() {
        const { collection, label, bindProperty, 
            nothingSelectedLabel, nItemsSelectedLabel,
            nItemsSelectedLimit } = this.options;
            
        return { 
            collection, label, bindProperty,
            nothingSelectedLabel, nItemsSelectedLabel,
            nItemsSelectedLimit 
        };
    },

    events: {

        'keydown input; click input; click .input-group-btn > button'({keyCode, currentTarget}) {
            if (keyCode == 9 || keyCode == 16 || keyCode == 17 || keyCode == 18) return;

            const { bindProperty, collection } = this.options;
            const selected = this.getBinding( bindProperty );
            pick( selected, 
                { collection, 
                    cluster: this.model.get( 'cluster' ),
                    clusters: this.options.clusters } )
                .then( newSelected => this.setBinding( bindProperty, newSelected ) )

            currentTarget.blur();
            return false; 
        },

    }

} );


// WEBPACK FOOTER //
// ./src/js/view/field/pick.js